import { baseApi } from "./index";

export const dashBoardApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashBoard: builder.query({
            query: () => ({
                url: "/dashboard",
                method: "GET",
            }),
            providesTags: ["DashBoard"],
        }),
    }),
});

export const {
    useGetDashBoardQuery,
} = dashBoardApi;
